import React from "react";
import { toast } from "sonner";
import { FileText, CircleNotch } from "@phosphor-icons/react";
import api, { formatApiError } from "@/lib/api";

// Lets the owner manually send one of the Auto-poruke templates, rendered for this reservation.
export function TemplatePicker({ reservationId, threadId, onPick }) {
  const [open, setOpen] = React.useState(false);
  const [templates, setTemplates] = React.useState(null);
  const [busy, setBusy] = React.useState(null);

  const toggle = async () => {
    setOpen((v) => !v);
    if (templates) return;
    try {
      const { data } = await api.get("/message-templates");
      setTemplates(Array.isArray(data) ? data : (data?.items || []));
    } catch (e) {
      toast.error(formatApiError(e));
      setTemplates([]);
    }
  };

  const pick = async (tpl) => {
    setBusy(tpl.id);
    try {
      const { data } = await api.post(`/message-templates/${tpl.id}/preview`, { reservation_id: reservationId || null, thread_id: reservationId ? null : threadId || null });
      onPick(data.rendered || "");
      setOpen(false);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(null);
    }
  };

  return (
    <div className="relative self-stretch">
      <button
        type="button"
        onClick={toggle}
        title={reservationId ? "Umetni predložak" : "Umetni predložak (razgovor nije vezan uz rezervaciju — varijable rezervacije ostat će prazne)"}
        className="flex h-full items-center gap-1 rounded-md border border-foreground/20 bg-card px-2.5 text-xs font-medium text-muted-foreground hover:bg-muted hover:text-foreground disabled:opacity-40"
        data-testid="inbox-template-btn"
      >
        <FileText size={15} /> <span className="hidden md:inline">Predložak</span>
      </button>
      {open && (
        <div className="absolute bottom-full right-0 z-30 mb-2 max-h-72 w-72 overflow-y-auto rounded-md border border-border bg-card p-1 shadow-lg" data-testid="inbox-template-menu">
          {templates === null && <div className="flex justify-center p-3"><CircleNotch size={16} className="animate-spin" /></div>}
          {templates?.length === 0 && <p className="p-3 text-xs text-muted-foreground">Nemate predložaka. Dodajte ih u Auto poruke.</p>}
          {templates?.map((t) => (
            <button
              key={t.id}
              onClick={() => pick(t)}
              disabled={!!busy}
              className="flex w-full items-start gap-2 rounded px-2.5 py-2 text-left text-xs hover:bg-muted disabled:opacity-50"
              data-testid={`inbox-template-item-${t.id}`}
            >
              {busy === t.id ? <CircleNotch size={13} className="mt-0.5 animate-spin" /> : <FileText size={13} className="mt-0.5 shrink-0 text-primary" />}
              <span className="min-w-0">
                <span className="block font-semibold text-foreground">{t.name}</span>
                {t.description && <span className="block truncate text-muted-foreground">{t.description}</span>}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
